module.exports = __webpack_public_path__ + "img/forward-inbox.6d96b719.svg";